<template>
  <aside class="left-sidebar bg-sidebar d-none d-md-block">
    <div id="sidebar" class="sidebar sidebar-with-footer">
      <!-- Application Brand -->
      <router-link :to="{ name: 'index' }">
        <div class="app-brand">
          <img :src="logo" width="200" height="65" class="w-100 px-4 pt-2 d-none d-md-block" alt="" />
        </div>
      </router-link>
      <!-- Sidebar Scrollbar -->
      <div class="sidebar-scrollbar">
        <ul class="nav sidebar-inner" :class="{ 'd-none d-sm-block': isAdmin }" id="sidebar-menu">
          <!-- Simple Menu Items (no submenu) -->
          <li v-for="item in simpleMenuItems" :key="item.id" :class="getMenuItemClass(item)">
            <router-link :to="item.route" class="sidenav-item-link ">
              <i :class="item.icon"></i>
              <span class="nav-text">{{ getTranslatedLabel(item) }}</span>
            </router-link>
          </li>
          <!-- Menu Items with Submenu -->
          <li v-for="item in submenuItems" :key="item.id" :class="getMenuItemClass(item)" class="has-sub">
            <a class="sidenav-item-link" href="javascript:void(0)" data-toggle="collapse" :data-target="`#${item.id}`"
              aria-expanded="true" :aria-controls="item.id">
              <i :class="item.icon"></i>
              <span class="nav-text">{{ getTranslatedLabel(item) }}</span>
              <i class="mdi mdi-chevron-down"></i>
            </a>
            <ul :class="{ collapse: !hasActiveChild(item.subItems) }" :id="item.id" data-parent="#sidebar-menu">
              <div class="sub-menu">
                <li v-for="subItem in getVisibleSubItems(item.subItems)" :key="subItem.id"
                  :class="{ active: isActive(subItem.route) }">
                  <router-link :to="subItem.route" class="sidenav-item-link g-2">
                    <i class="mr-2" :class="subItem.icon"></i>
                    <span class="nav-text">{{ getTranslatedLabel(subItem) }}</span>
                  </router-link>
                </li>
              </div>
            </ul>

          </li>

        </ul>
      </div>
      <hr class="separator" />
    </div>
  </aside>
</template>

<script>
import {
  getMenuItems,
  filterByPermissions,
  isMenuItemActive,
  getVisibleSubItems as getVisibleSubItemsHelper
} from '../navigationConfig';

import logo from "@/assets/img/nzidoo-logo.png";
import helper from '@/services/helper';
export default {
  name: 'Sidebar',
  computed: {
    logo() {
      return logo;
    },
    user() {
      return this.$store.state.user;
    },
    isAdmin() {
      return this.user?.roles?.includes('ROLE_ADMIN');
    },
    visibleMenuItems() {
      const items=getMenuItems(this.user);
      return filterByPermissions(items, this.user);
    },
    simpleMenuItems() {
      return this.visibleMenuItems.filter(item => !item.hasSubmenu);
    },
    submenuItems() {
      return this.visibleMenuItems.filter(item => item.hasSubmenu);
    }
  },
  methods: {
    isActive(routeName) {
      return this.$route.name===routeName;
    },
    hasActiveChild(subItems) {
      return subItems.some(sub => this.isActive(sub.routeName));
    }
    ,
    getMenuItemClass(item) {
      const classes=['expand'];

      if (isMenuItemActive(item, this.$route.name)) {
        classes.push('active');
      }
      return classes.join(' ');
    },
    getVisibleSubItems(subItems) {
      return getVisibleSubItemsHelper(subItems, this.user);
    },
    getTranslatedLabel: helper.getTranslatedLabel,
  }
};
</script>

<style scoped>
.left-sidebar {
  z-index: 101;
}

.sidebar {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
}

.app-brand {
  flex-shrink: 0;
  padding-bottom: 1rem;
}

.sidebar-scrollbar {
  flex: 1;
  width: 260px;
  overflow-y: auto;
  overflow-x: hidden;
  /* Custom scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.5) transparent;
}

/* Webkit browsers (Chrome, Safari, Edge) */
.sidebar-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.sidebar-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(155, 155, 155, 0.5);
  border-radius: 3px;
}

.sidebar-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(155, 155, 155, 0.7);
}

.separator {
  flex-shrink: 0;
  margin: 0;
}

.sidebar .sidenav-item-link .nav-text {
  white-space: nowrap;
  text-transform: none;
}
</style>